module.exports = __webpack_public_path__ + "img/Enzymotherapy01.b4911ad2.jpg";